import React from 'react'
export const Stepper = ({ activeStep, numOfSteps }) => (
    <div className="d-flex">
        {Array.from(Array(numOfSteps).keys()).map(step => {
            return (
                <div key={step} className={activeStep > step ? "stepper active" : "stepper"} />
            )
        })}
    </div>
)